import React from 'react';
export const CFIconCheckmarkSquare2 = {
    alias: 'checkmark-square-2',
    defaultTitle: 'Checkmark Square',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M19 12.834a1 1 0 0 1 2 0V18.4a2.604 2.604 0 0 1-2.6 2.601H5.6A2.604 2.604 0 0 1 3 18.4V5.601c0-1.434 1.167-2.6 2.6-2.6h9.567a1 1 0 1 1 0 2H5.6a.6.6 0 0 0-.6.6V18.4c0 .331.269.601.6.601h12.8c.331 0 .6-.27.6-.601v-5.566Zm-9.69-1.887a1 1 0 0 1 1.414.033l1.505 1.577 6.053-6.252a1 1 0 1 1 1.437 1.39l-6.777 7a.997.997 0 0 1-.718.306h-.004a1 1 0 0 1-.72-.31l-2.223-2.33a1 1 0 0 1 .033-1.415Z' }))),
};
